/*
 * @Description: 项目版本迭代提示用户，只在项目更新时，用户未关闭页面，已关闭页面则不提示
 */

let version; // 新版本
let hidden = false; // 页面是否隐藏
// 获取版本号
const getVersion = async () => {
  return fetch("/version.json?timestep=" + Date.now()).then(res => res.json());
};

// 检查更新
const checkUpdate = async () => {
  // console.log("开始检查版本……");
  // 获取最新版本
  version = (await getVersion()).version;

  // 手动刷新页面自动存入新版本
  window.onbeforeunload = function () {
    // 监听用户手动刷新页面
    sessionStorage.setItem("version", version); // 存入版本version
  };
  // 获取当前版本
  const currentVersion = sessionStorage.getItem("version") || false;
  if (!currentVersion) {
    // 本地没有 version，表示刚进入系统，直接塞值
    return sessionStorage.setItem("version", version);
  }
  if (version !== currentVersion) {
    // 调用更新
    if (!hidden) {
      // 页面隐藏了就不检查更新
      sessionStorage.setItem("version", version); // 存入版本version
      location.reload(true); // 刷新页面
      console.log('版本更新，刷新页面');
    }
  } else {
    // console.log("无版本更新");
    return;
  }
};


// 开始检查更新
const start = async () => {
  checkUpdate();
  // 监听页面是否隐藏
  document.addEventListener("visibilitychange", () => {
    hidden = document.hidden;
    // 页面隐藏了就不检查更新。或者已经有一个提示框了，防止重复提示。
    if (!hidden) {
      // console.log("页面隐藏");
      return;
    }
  });
};

export default { start };
